module.exports = __webpack_public_path__ + "static/media/pointer_icon.2f9d38f1.svg";